// extracted by mini-css-extract-plugin
module.exports = {"adStyleWrapper":"select-wrapper_adStyleWrapper__3VJRU","widgetStyleWrapper":"select-wrapper_widgetStyleWrapper__2hJu3","warningMessage":"select-wrapper_warningMessage__1ijOb"};